const normalizeName = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/** Names a dashboard tab can match against an assigned module or menu title. */
const TAB_NAMES = {
  PO: ["purchase order", "purchase orders"],
  ASN: ["advanced shipping notice", "advance shipping notice", "asn"],
  SO: ["sales order", "sales orders", "sales order sto"],
  SHIPMENT: ["shipment", "shipments", "shipment order"],
  GRN: ["goods receipt", "goods receipts", "grn"],
  INVENTORY: ["inventory visibility", "item inventory", "inventory"],
};

const isObjectId = (value) => /^[a-f0-9]{24}$/i.test(String(value || "").trim());

export function moduleLabel(item) {
  if (item == null) return "";
  if (typeof item === "string" || typeof item === "number") {
    return isObjectId(item) ? "" : String(item);
  }
  const label = item.label || item.name || item.title || item.moduleName || item.value || "";
  return isObjectId(label) ? "" : String(label);
}

export function collectMenuNames(items, names = []) {
  if (!Array.isArray(items)) return names;
  items.forEach((item) => {
    const title = moduleLabel(item?.title || item);
    if (title) names.push(normalizeName(title));
    if (item?.children?.length) collectMenuNames(item.children, names);
  });
  return names;
}

export function collectAssignedModuleNames(user) {
  if (!user || typeof user !== "object") return [];
  const sources = [
    user.moduleAccess,
    user.modules,
    user.moduleDetails,
    user.permissions?.modules,
    user.assignedModules,
  ];
  const names = [];
  sources.forEach((source) => {
    const list = Array.isArray(source) ? source : source ? [source] : [];
    list.forEach((item) => {
      const label = moduleLabel(item);
      if (label) names.push(normalizeName(label));
    });
  });
  return names;
}

function namesMatch(assigned, alias) {
  if (!assigned || !alias) return false;
  if (assigned === alias) return true;
  if (alias.length < 4 || assigned.length < 4) return false;
  return assigned.includes(alias) || alias.includes(assigned);
}

export function tabMatchesAssignedName(tab, assignedNames) {
  const aliases = TAB_NAMES[tab?.key] || [normalizeName(tab?.label)];
  return assignedNames.some((assigned) => aliases.some((alias) => namesMatch(assigned, alias)));
}

/**
 * Keep dashboard tabs whose name matches an assigned module.
 * Assigned names come from the user's module labels and the role menu titles.
 * Ids without a name are ignored. With no names yet, every tab stays so the
 * dashboard is not blank before menus load.
 */
export function filterDashboardTabs(tabs, { menus = [], user = null } = {}) {
  const assigned = [...collectAssignedModuleNames(user), ...collectMenuNames(menus)];
  if (!assigned.length) return tabs;
  return tabs.filter((tab) => tabMatchesAssignedName(tab, assigned));
}
